import {EdcUiFeature} from '../edc-ui-feature';

export const MDS_FEATURES: EdcUiFeature[] = ['mds-connector-id', 'mds-fields'];
